import React from 'react';
import classNames from 'classnames';
import css from './attention-message.module.scss';

export const AttentionMessage: React.FC<React.ComponentProps<'div'>> = ({
    children,
    className,
    ...restProps
}) => (
    <div className={classNames(css.root, className)} {...restProps}>
        {children}
    </div>
);
